import { Table, message } from 'antd';
import xlsx from 'json-as-xlsx';
// import { AgentPagedList } from 'api/agent';
import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import { createContext, useEffect, useState, useCallback } from 'react';
import FilterColumns from './FilterColumns';
import moment from 'moment';

import {
  PresentmentDashboard,
  presentmentDashboardFilter,
  PresentmentFilterPaylaod,
  PresentmentPagedList,
  //presentmentDashboardFilternew,
} from 'api/nach';
import { usePresentmentFilterContext } from 'features/nach/presentment/context/PresenmentFilterProvider';
// let payPagedList: AgentPagedList;
export const ReloadFilterListContext = createContext<any>(null);

let initialPresentmentPagedList: PresentmentPagedList = {
  currentPageIndex: 1,
  noOfRecords: 0, // Initialize with 0 or the appropriate default
  data: [],
};
type Props = {
  filter: PresentmentFilterPaylaod;
  reload: boolean;
};

function getFullDate(date: string) {
  if (date != null) {
    let dateMoment = moment(new Date(date)).format('YYYY/DD/MM HH:mm:ss');
    return dateMoment;
  }
}

const FilteredPresentmentList = ({ }: Props) => {
  const [pagedList, setPagedList] = useState<PresentmentPagedList>(initialPresentmentPagedList); // Use the PresentmentPagedList type
  //const [pagedList, setPagedList] = useState<PresentmentDashboard[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isRetry, setIsRetry] = useState(false);
  const { filter, setFilter, currentActiveTabKey, prevFilter } = usePresentmentFilterContext();
  const [fetchedDate, setFetchedDate] = useState('');


  // Local state for pagination parameters
  // const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Default page size

  // filter.Username = sessionStorage.getItem('user')?.toString();
  const isAdmin = sessionStorage.getItem('isAdmin');

  if (isAdmin != 'true') {
    // filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  }
  useEffect(() => {
    console.log("filteredPresentmentListcheck Nach filter--------", filter)

    if (!filter || !filter.startDate || !filter.endDate) {
      // console.log("filteredPresentmentListcheck1234--------", filter)
      setIsLoading(true);
      setPagedList(initialPresentmentPagedList);
      // message.warn('Please select date');
      return;
    }
    //setIsLoading(true);
    if (filter?.isExtract && currentActiveTabKey == 2) {
      //setIsLoading(false);
      // setIsLoading(false);
      handleDownloadData();
      return
    }
    //console.log("filteredPresentmentListchecksdfghj--------", filter)
    // If download is requested (isExtract is true), fetch ALL data
    // if (filter?.isExtract && currentActiveTabKey == 2) {
    //   console.log("---DOWNLOAD TRIGGERED---", filter);
    //   setIsLoading(false); // Show loading for download
    //   const downloadPayload: PresentmentFilterPaylaod = {
    //     ...filter,
    //     presentmentFlagId: 1, // Assuming this is the correct flag for this list
    //     isExtract: true, // Confirming extraction
    //     pageNo: 1, // Or a value your backend understands as "all pages"
    //     pageSize: pageSize, // Or a value your backend understands as "all items"
    //   };

    //   presentmentDashboardFilter(downloadPayload)
    //     .then((res) => {
    //       console.log('Download data fetched', res);
    //       if (res.data && res.data.data.length > 0) { // Ensure res.data and res.data.data exist
    //         performExcelDownload(res.data.data); // Pass the actual data array
    //       } else {
    //         message.destroy();
    //         message.error('No data found for download in Natch List.');
    //       }
    //     })
    //     .catch((error) => {
    //       console.error('Error fetching data for download:', error);
    //       message.error('Failed to download data.');
    //     })
    //     .finally(() => {
    //       setIsLoading(true); // Hide loading after download attempt
    //       const resetFilter = { ...filter, isExtract: false };
    //       setFilter(resetFilter);
    //       //message.destroy(); // Hide loading message
    //     });
    //   return; // Exit useEffect if a download is being processed
    // }

    // if (!filter || !filter.startDate || !filter.endDate) {
    //   // console.log("filteredPresentmentListcheck1234--------", filter)
    //   setIsLoading(true);
    //   // message.warn('Please select date');
    //   return;
    // }
    if (currentActiveTabKey != 2 && prevFilter != JSON.stringify(filter)) {
      // console.log("filteredPresentmentdddddd--------", filter)

      return;
    }


    // This is the key change to prevent re-fetching after a download.
    const filterForTableFetch = { ...filter };
    delete filterForTableFetch.isExtract;
    delete filterForTableFetch.pageNo;
    delete filterForTableFetch.pageSize;
    const filterForTableFetchString = JSON.stringify(filterForTableFetch);

    if (fetchedDate != filterForTableFetchString && currentActiveTabKey == 2 && !filter?.isExtract) {
      // console.log("filteredPresentmentdddddd-ddddddddddd-------", filter)
      setFetchedDate(filterForTableFetchString);
      //setFetchedDate(JSON.stringify(filter));
      setIsLoading(false);
      //setPagedList([]);
      setPagedList(initialPresentmentPagedList); // Reset pagedList when filter changes
      //setCurrentPage(1); // Reset to first page on new filter
      //const newFilter: PresentmentFilterPaylaod = { ...filter, presentmentFlagId: 1 };
      const newFilter: PresentmentFilterPaylaod = {
        ...filter,
        presentmentFlagId: 1,
        pageNo: 1, // Always start at page 1 for a new filter fetch
        pageSize: pageSize, // Use current pageSize
      };
      presentmentDashboardFilter(newFilter)
        .then((res) => {
          console.log('nach data presentment', res);
          if (res.data) {
            setPagedList(res.data);
          }
        })
        .finally(() => {
          setIsLoading(true);
        });
    }

    // Handle cases where the tab changes away from 2, or filter changes when not on tab 2
    // else if (currentActiveTabKey !== 2 && prevFilter !== JSON.stringify(filter)) {
    //   // Potentially reset state or handle differently if needed when tab is not active
    //   console.log("else if-------")
    //   setPagedList(initialPresentmentPagedList);
    //   setIsLoading(true);
    // }
  }, [isRetry, filter, currentActiveTabKey, pageSize]);


  // === New useEffect for Download Trigger Only ===
  // useEffect(() => {
  //   // This effect runs ONLY when isExtract is true and on the correct tab
  //   if (filter?.isExtract && currentActiveTabKey == 2) {
  //     console.log("---DOWNLOAD TRIGGERED---", filter);
  //     handleDownloadData();
  //     // Reset the flag to avoid re-triggering this effect
  //     setFilter((prevFilter: PresentmentFilterPaylaod) => ({
  //       ...prevFilter,
  //       isExtract: false,
  //     }));
  //   }
  // }, [filter?.isExtract, currentActiveTabKey, setFilter]); // Dependencies are filter.isExtract, tab, and the callback
  const handleDownloadData = useCallback(() => {
    console.log("---------------Inside download ------------------")
    //setIsLoading(false);
    const downloadPayload = {
      ...filter,
      presentmentFlagId: 1,
      isExtract: true, // Signal to backend to potentially return all data
      pageNo: 1, // Always start from page 1 for full download
      pageSize: 99999, // Request a very large page size to get all data
    };

    presentmentDashboardFilter(downloadPayload)
      .then((res) => {
        console.log('Download data fetched by handleDownloadNach:', res);
        if (res.data && res.data.data && res.data.data.length > 0) {
          performExcelDownload(res.data.data);
          //message.success('Download complete!');
        } else {
          message.error('No data found for download in Nach');
        }
      })
      .catch((error) => {
        console.error('Error fetching data for download in handleDownloadNach:', error);
        message.error('Failed to download data.');
      })
      .finally(() => {
        message.destroy(); // Hide loading message
        //setIsLoading(true); // Hide component-level loading
        // Optionally, reset isExtract in filter if your backend's behavior
        // is affected by it being true after a download request.
        // const resetFilter = { ...filter, isExtract: false };
        // setFilter(resetFilter);
        setFilter((prevFilter: PresentmentFilterPaylaod) => ({
          ...prevFilter,
          isExtract: false,
        }));
      });
  }, [filter, setFilter]); // Dependency on filter to ensure latest filter values are used

  const performExcelDownload = (dataToDownload: PresentmentDashboard[]) => {
    let settings = {
      fileName: 'presentment_NACH',
      extraLength: 3,
      writeMode: 'writeFile',
      writeOptions: {},
      RTL: false,
    };

    const updatedData = dataToDownload.map((item: any, index) => ({
      ...item,
      NOTIFICATIONDATE: getFullDate(item.notificationDate),
      DATEOFTXN: getFullDate(item.dateOfTxn),
      CREATEDON: getFullDate(item.createdOn),
      ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
    }));

    let data = [
      {
        sheet: 'Sheet 1',
        columns: [
          { label: 'ROWNUM', value: 'ROWNUM' },
          { label: 'UMRN NO', value: 'umrnNO' },
          { label: 'Corporate Name', value: 'corporateName' },
          { label: 'Corporate User No', value: 'corporateUserNo' },
          { label: 'Amount', value: 'amount' },
          { label: 'Batch No', value: 'batchNo' },
          { label: 'Created On', value: 'CREATEDON' },
          { label: 'Customer Debit AC', value: 'customerDebitAC' },
          { label: 'Customer MICR', value: 'customerMICR' },
          { label: 'Date of Transaction', value: 'DATEOFTXN' },
          { label: 'Debitor Name', value: 'debtorName' },
          { label: 'IFSC', value: 'ifsc' },
          { label: 'Loan Type', value: 'loanType' },
          { label: 'Merchant Order ID', value: 'merchantOrderId' },
          { label: 'Merchant Subscription ID', value: 'merchantSubscriptionId' },
          { label: 'Partner Bank', value: 'partnerBank' },
          { label: 'Transaction ID REF', value: 'transactionIDREF' },
          { label: 'Unique Reference', value: 'uniqueReference' },
          { label: 'Created By', value: 'userName' }
        ],
        content: updatedData,
      },
    ];
    xlsx(data, settings);
  };


  if (!isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {


    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }

    // Update pagination state
    //setCurrentPage(_pagination.current);
    setPageSize(_pagination.pageSize);

    setIsLoading(false);

    // filter.Username = sessionStorage.getItem('user')?.toString();
    if (isAdmin != 'true') {
      // filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    }
    const newFilter: PresentmentFilterPaylaod = {
      ...filter,
      presentmentFlagId: 1,
      pageNo: _pagination.current, // Use the page from Ant Design's pagination
      pageSize: _pagination.pageSize, // Use the page size from Ant Design's pagination
    };
    presentmentDashboardFilter(newFilter)
      .then((res) => {
        if (res.data) {
          setPagedList(res.data);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  const maxWidthPerCell = 600;

  const dataTable = calculateColumnsWidth(FilterColumns, pagedList.data || [], maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <ReloadFilterListContext.Provider value={{ setIsRetry, isRetry }}>
      <Table
        dataSource={dataTable.source}
        columns={dataTable.columns}
        rowKey={rowKey}
        //pagination={false}
        // pagination={
        //   {
        //     // pageSize: 10,
        //     // total: pagedList.noOfRecords - 10,
        //     // current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
        //   }
        // }
        pagination={{
          pageSize: pageSize, // Use the state variable for page size
          total: pagedList.noOfRecords, // Total records from your API response
          current: pagedList.currentPageIndex === 0 ? 1 : pagedList.currentPageIndex, // Current page from your API response
          showSizeChanger: true, // Allow changing page size
          pageSizeOptions: ['10', '20', '50', '100'], // Options for page size
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`, // Optional: show total items
        }}
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        onChange={handleChange}
      />
    </ReloadFilterListContext.Provider>
  );
};
export default FilteredPresentmentList;
